import { Location } from "@angular/common";
import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { PatientService } from "@main/app-layout/components/patient-switch/patient.service";
import { FormButtonsConfig } from "@mipro/components";
import { IEpisode } from "@project/models/episodes/episode";
import { EpisodeSelectMode } from "./episode-select-mode";
import { EpisodeSelectOption } from "./episode-select-option";
import { RavenApiService } from "@main/raven/raven-api.service";
import { createGenericPrescriptionEpisode } from "./episode-defaults";

@Component({
    selector: "episode-select-dialog",
    template: ` <p-dialog
        [header]="header"
        [visible]="visible"
        [modal]="modal"
        [closable]="closable"
        [draggable]="draggable"
        [style]="style">
        <div class="inputs-group pt-2">
            <div class="inputs-group-row">
                <episode-select
                    *ngIf="visible"
                    #episodeOpt="ngModel"
                    [selectionModes]="selectionModes"
                    [offlineInvalidModes]="offlineInvalidModes"
                    [(ngModel)]="episodeSelectOption"
                    [originallySelectedOption]="episodeSelectOption"
                    [ngModelOptions]="{ standalone: true }"
                    [restoreDuplicateCheakState]="restoreDuplicateCheakState"
                    [restoreSelectControlState]="restoreSelectControlState"
                    [isWalkInDraft]="isWalkInDraft"
                    [isPrescription]="isPrescription"
                    [patientId]="patientService.currentPatientId"
                    [assignedClinicianId]="assignedClinicianId"
                    required>
                </episode-select>
                <control-errors *ngIf="visible" [control]="episodeOpt"></control-errors>
            </div>
        </div>
        <form-buttons allowOffline [disabled]="buttonsDisabled" [config]="selectEpisodeButtonsConfig"></form-buttons>
    </p-dialog>`
})
export class EpisodeSelectDialogComponent {

    @Input() episodeSelectOption: EpisodeSelectOption;
    @Input() header = "Please select an episode";
    @Input() modal = true;
    @Input() closable = false;
    @Input() draggable = true;
    @Input() style: any = { minWidth: "400px" };
    @Input() restoreDuplicateCheakState: boolean;
    @Input() restoreSelectControlState: boolean;
    @Input() isWalkInDraft: boolean;
    @Input() isPrescription: boolean;
    @Input() visible = false;
    @Input() selectionModes: EpisodeSelectMode[] = [
        EpisodeSelectMode.RoutineTreatment,
        EpisodeSelectMode.ExistingEpisode,
        EpisodeSelectMode.NewEpisode
    ];
    @Input() offlineInvalidModes: EpisodeSelectMode[] = [
        EpisodeSelectMode.ExistingEpisode,
        EpisodeSelectMode.NewEpisode,
        EpisodeSelectMode.EditEpisode
    ];
    @Input() assignedClinicianId: string;

    @Output() readonly visibleChange = new EventEmitter<boolean>();
    @Output() readonly episodeChange = new EventEmitter<IEpisode>();
    @Output() readonly cancel = new EventEmitter<void>();

    get buttonsDisabled() {
        var episode_is_null = !this.episodeSelectOption?.episode
        var disabled = episode_is_null;

        return disabled;
    }

    selectEpisodeButtonsConfig = <FormButtonsConfig>{
        saveLabel: "Ok",
        saveFunc: () => {
            this.episodeChange.emit(this.episodeSelectOption?.episode);
            this.hideDialog();
        },
        cancelFunc: () => {
            this.cancel.emit();
            this.hideDialog();
        }
    };
    ravenEnabled: boolean;

    constructor(public patientService: PatientService,
        private location: Location,
        public ravenApiService: RavenApiService, ) {
            this.ravenEnabled = this.ravenApiService.isRavenModuleEnabled();
    }

    private hideDialog() {
        this.visible = false;
        this.visibleChange.emit(false);
    }

    selectedEpisodeIsGeneric(): boolean {
       if (!this.episodeSelectOption) {
           return false;
       }
       return createGenericPrescriptionEpisode().id === this.episodeSelectOption.episode?.id;
    }

}